export default "__VITE_ASSET__yl0OMIIW__"